import { createSlice } from '@reduxjs/toolkit';
import ISliceState from '@/interface/core/ISliceState';
import { sliceStateStatus } from '@/Core';

import {
  searchInvoke

  , setSearchData
  , removeSearchData
} from './searchActions';

import ISearch from '@/interface/core/ISearch';

const initialState: ISliceState = {
  data: undefined,
  status: sliceStateStatus.idle,
  ids: [],
  params: undefined,
  emailcount: undefined,
  sentcount: undefined, 
};


  /*
setSearchData: (state, action) => { 
  state.data = { 
    page: '1'
    , term: ''
    , data: {}
  } as ISearch;
  Object.assign(state.data = action.payload)
  

  return {
    ...state,
    data: {
      ...state.data,
      data: {
        ...data,
        ...action.payload
      }
      
    }
  }
  

},
removeSearchData: () => (initialState)
*/


const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    
      .addCase(setSearchData, (state, action) => {
        //console.log('setSearchData - ' + JSON.stringify(action.payload))
        state.data = {} as ISearch;
        Object.assign(state, action.payload);
        
        //return {
        //  ...state,
        //  data: {
        //    ...state.data,
        //    ...action.payload
        //  }
        //}
        
      })
      .addCase(removeSearchData, (state, action) => {
        //console.log('removeSearchData')
        return initialState;
      })
    
      .addCase(searchInvoke.fulfilled, (state, action) => {
        state.data = action.payload.data; 
        state.ids = action.payload.ids;
        state.emailcount = action.payload.emailcount;
        state.sentcount = action.payload.sentcount;
        state.params = action.payload.params;
        state.status = sliceStateStatus.fulfilled; 
      })
      .addCase(searchInvoke.pending, (state, action) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(searchInvoke.rejected, (state, action) => {
        state.status = sliceStateStatus.rejected;
      })
      
      ;
  },
});

//export const { setSearchData, removeSearchData } = searchSlice.actions
export default searchSlice.reducer;